import { useEffect } from 'react'
import { showLoader } from '@/stores/ui.store.ts'

export function LazyLoader() {
  useEffect(() => {
    showLoader(true);
    return () => {
      showLoader(false);
    }
  }, [])
  return null;
}